import { effect } from "../fmt";
import { Effect } from "./Effect";
import type { ItemProfileData, Ruleset } from "./Ruleset";

export class ItemProfile {
  ruleset: Ruleset;
  data: ItemProfileData;

  constructor(ruleset: Ruleset, data: ItemProfileData) {
    this.ruleset = ruleset;
    this.data = data;
  }

  get id() {
    return this.data.id;
  }

  get name() {
    return this.data.name;
  }

  get type() {
    return this.data.type;
  }

  get effects() {
    return (
      this.data.effects?.map((data) => Effect.from(this.ruleset, data)) ?? []
    );
  }

  get summary() {
    return this.effects.map(effect).join(" ");
  }
}
